module.exports = __webpack_public_path__ + "img/logo.4eabb1ad.png";